import React from 'react';

const DashboardCasePopup = () => {
    return (
        <div className="  bg-white w-[600px] shadow-xl p-4 z-50">

            <div className="relative overflow-x-auto">
                <table className="w-full  border border-dark-blue-200 text-sm text-left">
                    <thead className="text-sm text-white font-medium bg-dark-blue-200   ">
                    <tr>
                        <th scope="col" className="px-6 py-3">
                            Conditions
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="bg-white ">
                        <td className="px-4 py-3">
                            User can filter region of data to be
                            displayed
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DashboardCasePopup;